/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {ClearSnapshots, RestoreSnapshot} from './ngxs-snapshot.actions';
import {NgxsSnapshotStateModel} from './ngxs-snapshot.model';
import { Injectable } from '@angular/core';

@State({
    name: 'snapshots',
    defaults: {
        groups: []
    }
})
@Injectable()
export class NgxsSnapshotState {
    @Selector()
    static snapshotCount(state: NgxsSnapshotStateModel) {
        return (group: string) => {
            return state.groups[group] && state.groups[group].length || 0;
        };
    }

    @Action(RestoreSnapshot)
    restorePrevious({}: StateContext<NgxsSnapshotStateModel>, action: RestoreSnapshot) {}

    @Action(ClearSnapshots)
    clearSnapshots({}: StateContext<NgxsSnapshotStateModel>, action: ClearSnapshots) {}
}
